import React, { useState } from "react";
import * as Yup from "yup";
import axios from "axios";
import swal from "sweetalert";
// import ReCAPTCHA from "react-google-recaptcha";
import "./Modal.scss";
import { Formik, Form, Field } from "formik";

const Modal = (props) => {
  // const captchaRef = useRef();

  // Función para obtener UTMs, referrer y URL actual
  const getUTMData = () => {
    const params = new URLSearchParams(window.location.search);
    const referrer = document.referrer || "direct";

    return {
      utm_source: params.get("utm_source") || (referrer !== "direct" ? (() => { try { return new URL(referrer).hostname.replace("www.", ""); } catch { return referrer; } })() : "direct"),
      utm_medium: params.get("utm_medium") || (referrer !== "direct" ? "referral" : "none"),
      utm_campaign: params.get("utm_campaign") || "",
      utm_term: params.get("utm_term") || "",
      utm_content: params.get("utm_content") || "",
      referrer: referrer,
      current_url: window.location.href
    };
  };

  // Validación con Yup
  const SignupSchema = Yup.object().shape({
    name: Yup.string().min(2, "Mínimo 2 caracteres").max(100, "Máximo 100 caracteres").required("Campo requerido"),
    phone: Yup.string().matches(/^[0-9]{10}$/, "Debe tener 10 dígitos").required("Campo requerido"),
    email: Yup.string().email().required("Campo requerido"),
    contactTime: Yup.string().min(2, "Mínimo 2 caracteres").max(50, "Máximo 50 caracteres").required("Campo requerido"),
    // recaptcha: Yup.string().required("Llenar captcha"),
  });

  const obtenerSiguienteID = async () => {
    try {
      const response = await fetch("https://vistavelasunset.grupovelas.com/get_next_id.php");
      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
      const data = await response.json();
      return data.next_id || "N/A";
    } catch (error) {
      console.error("Error al obtener el siguiente ID:", error);
      return "N/A";
    }
  };

  const descargarBrochure = () => {
    const link = document.createElement("a");
    link.href = "/assets/Home/Brochure_PuntaVela_opt.pdf";
    link.target = "_blank";
    link.download = "Brochure.pdf";
    link.click();
  };

  return (
    <div className="contenedor_modal">
      <p onClick={() => props.setModal(false)} className="closed">X</p>
      <div className="contenedor_modal_form">
        <img src="/assets/Home/iconos-logos/img_logo_puntavela.svg" alt="" />
        <h2>¿DESEAS MÁS INFORMACIÓN?</h2>
        <p>
          Completa tus datos y, en breve, uno de nuestros asesores te contactará
          para brindarte más detalles sobre nuestras residencias.
        </p>

        <Formik
          initialValues={{
            name: "",
            phone: "",
            email: "",
            contactTime: "",
            // recaptcha: "",
          }}
          validationSchema={SignupSchema}
          onSubmit={async (values, { resetForm }) => {
            const siguienteID = await obtenerSiguienteID();
            const utmData = getUTMData();

            const data1 = {
              id: siguienteID,
              Nombre: values.name,
              Apellidos: "Sin Apellido",
              Telefono: values.phone,
              Movil: values.phone,
              Correo: values.email,
              Descripcion: values.contactTime,
              ClaveDesarrollo: "jrz-004",
              Campana: "CP-0160",
              Medio: "MPUB-0022",
              CorreoAgente: "erios@velasresorts.com",
              CorreoAgenteTitular: "erios@velasresorts.com",
              TipoPersona: "F",
              referer: utmData.current_url,
              utm_source: utmData.utm_source,
              utm_medium: utmData.utm_medium,
              utm_campaign: utmData.utm_campaign,
              utm_term: utmData.utm_term,
              utm_content: utmData.utm_content,
              referrer: utmData.referrer,
              current_url: utmData.current_url,
            };

            const data2 = {
              name: values.name,
              phone: values.phone,
              email: values.email,
              contactTime: values.contactTime,
              utm_source: utmData.utm_source,
              utm_medium: utmData.utm_medium,
              utm_campaign: utmData.utm_campaign,
              utm_term: utmData.utm_term,
              utm_content: utmData.utm_content,
              referrer: utmData.referrer,
              current_url: utmData.current_url,
            };

            console.log("Enviando a vistavelasunset:", data1);
            console.log("Enviando a puntavela-juarez:", data2);

            try {
              const response2 = await axios.post("https://puntavela-juarez.com/php/sendEmailPuntaVela.php", data2);

              if (response2.data.success) {
                axios.post("https://vistavelasunset.grupovelas.com/send_lead.php", data1).catch((e) =>
                  console.error("CRM error (no crítico):", e)
                );
                await swal("Enviado", "Los datos han sido enviados correctamente", "success");
                resetForm();
                descargarBrochure();
              } else {
                throw new Error(response2.data.error?.message || "Error en el servidor");
              }
            } catch (error) {
              console.error("Error en la solicitud:", error);
              swal("Error", "Hubo un problema al enviar el formulario.", "error");
            }
          }}
        >
          {({ errors, touched, handleSubmit, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <Field name="name" placeholder="Nombre" />
              {errors.name && touched.name && <div className="error">{errors.name}</div>}

              <Field name="phone" type="text" placeholder="Teléfono" />
              {errors.phone && touched.phone && <div className="error">{errors.phone}</div>}

              <Field name="email" type="email" placeholder="Correo electrónico" />
              {errors.email && touched.email && <div className="error">{errors.email}</div>}

              <Field name="contactTime" placeholder="Horario de contacto preferido" />
              {errors.contactTime && touched.contactTime && <div className="error">{errors.contactTime}</div>}

              {/* <Field name="recaptcha">
                {({ meta }) => {
                  const handleChange = (value) => setFieldValue("recaptcha", value);
                  return (
                    <>
                      <ReCAPTCHA
                        ref={captchaRef}
                        sitekey="6Ldod54pAAAAANWSl_Uk3F9bYRp656TRSO2lgqun"
                        onChange={handleChange}
                      />
                      {meta.error && meta.touched && <div className="error">{meta.error}</div>}
                    </>
                  );
                }}
              </Field> */}

              <p>Al enviar acepta nuestra <a onClick={() => props.setModalAviso(true)}>Política de privacidad</a></p>
              <button className="button_send" type="submit">Enviar</button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Modal;
